import React, { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Dialog, Section } from '@radix-ui/themes';

import PageTitle from 'components/layout/PageTitle';
import TableWrapper from 'components/table/TableWrapper';
import { ConfirmDialog } from 'components/dialog';

import { instance } from 'api/axios.instance';

// 사업공고 관리
export default function Announcement() {
  const boardType = 'announcement';

  // hooks
  const [searchParams] = useSearchParams();

  // state
  const [fetchData, setFetchData] = useState({ list: [], pagination: {} }); // 실태 조사 목록
  const [loading, setLoading] = useState(false); // 로딩 상태
  const [isOpenIsViewDialog, setIsOpenIsViewDialog] = useState(false); // 노출 여부 변경 모달
  const [isViewState, setIsViewState] = useState(true); // 노출 여부 상태 (true || false)
  const [crawlingCode, setCrawlingCode] = useState(''); // 노출 여부 크롤링 데이터 코드

  // 테이블 헤더 (테이블 내 형식 및 이벤트 관리)
  const tableHeader = [
    { label: '번호', key: 'index', width: '70px' },
    { label: '제목', key: 'title', width: 'auto', left: true, className: 'crawling', code: 'urlLink' },
    { label: '기관명', key: 'reference', width: '200px' },
    { label: '게시일', key: 'createDate', width: '120px' },
    {
      label: '노출 여부',
      key: 'isView',
      width: '108px',
      code: 'id',
      option: {
        label: { false: '노출안함', true: '노출' },
        class: { false: 'rt-gray disabled-button' },
        value: {
          false: {
            clickEvent: code => {
              setIsViewState(true);
              setCrawlingCode(code);
              setIsOpenIsViewDialog(true);
            }
          },
          true: {
            clickEvent: code => {
              setIsViewState(false);
              setCrawlingCode(code);
              setIsOpenIsViewDialog(true);
            }
          }
        }
      }
    }
  ];

  // 크롤링 데이터 목록 API
  const fetchList = useCallback(async () => {
    setLoading(true);
    try {
      const searchTypeMap = {
        제목: 'title',
        기관명: 'reference'
      };
      const isView = searchParams.get('isView');

      const response = await instance('/admin/crawling/list', {
        method: 'POST',
        data: {
          category: boardType,
          pageNo: Number(searchParams.get('page')) || 1, // 페이지 번호
          searchType: searchTypeMap[searchParams.get('searchType')] || '', // 검색 카테고리
          search: searchParams.get('search') || '', // 검색어
          ...(isView === 'true' || isView === 'false' ? { isView: isView === 'true' } : {})
        }
      });
      setFetchData({ pagination: response.data.data.pagination, list: response.data.data.crawlings });
    } finally {
      setLoading(false);
    }
  }, [searchParams]);

  // 크롤링 데이터 수정 API (노출여부 변경)
  const handleUpdateIsUsed = async () => {
    const response = await instance(`/admin/crawling/edit`, {
      method: 'POST',
      data: {
        id: crawlingCode, // 크롤링 데이터 아이디
        category: boardType, // 카테고리
        isView: isViewState // 노출여부
      }
    });

    if (response.data.status === 201) {
      await fetchList();
    }
  };

  // mount 및 searchParams 변경 시 호출
  useEffect(() => {
    fetchList();
  }, [fetchList, searchParams]);

  return (
    <>
      <Section>
        <PageTitle title="사업공고 목록" />
        <TableWrapper tableData={{ tableHeader, tableBody: fetchData }} boardType={boardType} loading={loading} fetchList={fetchList} />
      </Section>

      {/* 노출여부 Dialog */}
      {isOpenIsViewDialog && (
        <Dialog.Root open={isOpenIsViewDialog} onOpenChange={setIsOpenIsViewDialog}>
          <ConfirmDialog
            title="노출여부 변경"
            description={
              <>
                노출 여부를 <span className="font-info">‘{isViewState ? '노출' : '노출안함'}’</span>으로 변경 하시겠습니까?
              </>
            }
            onConfirm={handleUpdateIsUsed}
          />
        </Dialog.Root>
      )}
    </>
  );
}
